import axios from 'axios';
import { defineStore } from 'pinia';

export const useMonitoringStore = defineStore('monitoring', {
    state: () => ({}),

    actions: {
        async fetchStatus() {
            const { data } = await axios.get('monitoring/status');
            return data;
        },

        // Bud { hours }, alebo vlastne obdobie { from, to }.
        async fetchServerHistory(params) {
            const { data } = await axios.get('monitoring/server-history', { params });
            return data;
        },

        async fetchIncidents(params) {
            const { data } = await axios.get('monitoring/incidents', { params });
            return data;
        },

        async fetchIncident(id) {
            const { data } = await axios.get(`monitoring/incident/${id}`, {
                params: { includes: 'occurrences' }
            });
            return data;
        },

        async closeIncident(id) {
            const { data } = await axios.post(`monitoring/incident/${id}/close`);
            return data;
        },

        /*
         * Synchronizácie bežia na inom serveri. E-shop volania preposiela,
         * takže Amos ich nerozlišuje od ostatných — len tieto môžu vrátiť
         * 503, keď je sync server nedostupný.
         */

        async fetchSyncStatus() {
            const { data } = await axios.get('sync/status');
            return data;
        },

        async fetchSyncRuns(params) {
            const { data } = await axios.get('sync/runs', { params });
            return data;
        },

        async fetchSyncRun(id, params) {
            const { data } = await axios.get(`sync/runs/${id}`, { params });
            return data;
        },

        async runSync(key) {
            const { data } = await axios.post(`sync/${key}/run`);
            return data;
        }
    }
});
